import * as React from 'react';
import { connect } from 'react-redux';
import Select, { Option } from 'react-select';

import { IRootState } from '../../../store/MessageForm';
import { actions } from '../../../ducks/MessageForm';
import GlyphPopover from '../../../lib/components/GlyphPopover';
import { getDispatch } from '../../../lib/dispatchExporter';
import I18n from '../../../lib/i18n';
import SelectSuggestMovieList from './SelectSuggestMovieList';
import notify from '../../../lib/notify';
import SingleProductRow from '../SingleProductRow';

function mapStateToProps(state: IRootState) {
  return {
    suggestVideoList: state.$$formStore.suggestVideoList,
    byCountryGroup: state.$$formStore.byCountryGroup,
    relatedProducts: state.$$formStore.relatedProducts,
    countries: state.$$formStore.message.countries,
    timezone: state.$$formStore.timezone,
    platforms: state.$$formStore.message.platforms,
    hasNxNewsFormLevel: state.$$formStore.message.hasNxNewsLevel()
  };
}
interface IState {
  nsUid: string;
}

type Props = ReturnType<typeof mapStateToProps>;

class SuggestVideoListForm extends React.PureComponent<Props, IState> {
  private dispatch = getDispatch();

  public state = {
    nsUid: '',
  };

  private handleOpenSelect = () => {
    const { relatedProducts } = this.props;
    const hasSuperset = relatedProducts.get('hasSuperset');
    if (!relatedProducts.isFetching && !hasSuperset) {
      this.dispatch(actions.fetchProductsRequest());
    }
  };

  private notifyProductNotFound = () => {
    notify({
      title: '',
      message: I18n.t('message_details.error.product_video_not_found'),
      type: 'danger'
    });
  }

  public handleProductChange = (e: Option<string>) => {
    if (e === null) return;
    const nsUid = e.value;
    if (nsUid === undefined) { return; }
    const { relatedProducts } = this.props;
    const {
      updateSuggestVideoList,
      fetchSuggestVideoListRequest,
    } = actions;

    const product = relatedProducts.items.get(nsUid);
    if (product === undefined) { return; }

    this.dispatch(updateSuggestVideoList({
      key: 'selectedProduct',
      value: product.toSelectOption(),
    }));
    this.dispatch(fetchSuggestVideoListRequest());
  }

  public handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ nsUid : e.target.value });
  }

  public handleClick = () => {
    const nsUid = this.state.nsUid.trim();
    if (!nsUid) {
      this.notifyProductNotFound();
      return;
    }
    const { platforms, suggestVideoList } = this.props;
    // 重複チェック
    if (nsUid === suggestVideoList.selectedProduct.value) {
      this.dispatch(actions.fetchProductByIdFailed(I18n.t('message_details.error.product_duplicated')));
      notify({
        title: '',
        message: I18n.t('message_details.error.product_duplicated'),
        type: 'danger',
      });
      return;
    }
    this.dispatch(actions.fetchProductAndSuggestVideoListRequest({
      nsUid,
      platforms,
      afterFetch: (succeeded: boolean) => {
        if (succeeded) {
          this.setState({nsUid: ''});
        } else {
          this.notifyProductNotFound();
        }
      }
    }));
  };

  public handleDeleteClick = () => {
    this.dispatch(actions.updateSuggestVideoList({
      key: 'selectedProduct',
      value: '',
    }));
    this.setState({nsUid: ''});
  }

  public render() {
    const { relatedProducts, countries, suggestVideoList, byCountryGroup, timezone, platforms, hasNxNewsFormLevel } = this.props;
    const { nsUid } = this.state;
    const selectedNsUid = suggestVideoList.selectedProduct.value;
    if (!byCountryGroup) { return null; }

    return (
      <div style={{ marginBottom: '5px' }}>
        <label htmlFor="suggest-video-list" className="control-label">
          {I18n.t('message_details.form.suggest_video_list.title')}
        </label>
        <GlyphPopover
          title={I18n.t('message_details.form.suggest_video_list.title')}
          body={I18n.t('message_details.tooltips.suggest_video_list.main')}
        />
        <br />
        <div className="row">
          <div className="col-md-10">
            { hasNxNewsFormLevel ?
              <div className="row">
                <div className="col-md-7">
                  <input
                    type="text"
                    name="suggest-video-list-input"
                    value={nsUid}
                    placeholder={I18n.t('message_details.form.fetch_product_by_id_placeholder')}
                    className="form-control"
                    onChange={this.handleChange} />
                </div>
                <div className="col-md-5" style={{ marginBottom: '10px' }}>
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={this.handleClick}
                    disabled={!nsUid || relatedProducts.isFetching || !countries.size}
                  >
                    {I18n.t('common.action.add')}
                  </button>
                </div>
              </div>
            :
              <div style={{ marginBottom: '10px' }}>
                <Select
                  name="suggest-video-list-select"
                  options={relatedProducts
                    .filterAvailableCountriesOnlySoftDetail(
                      countries.map((e: any) => e.iso2).toArray(),
                      platforms
                    )
                  }
                  isLoading={relatedProducts.isFetching}
                  disabled={relatedProducts.isFetching}
                  value={suggestVideoList.selectedProduct}
                  onChange={this.handleProductChange}
                  clearable={false}
                  menuContainerStyle={{ position: 'relative' }}
                  onFocus={this.handleOpenSelect}
                />
              </div>
            }
            { selectedNsUid &&
              <SingleProductRow
                product={relatedProducts.getItem(selectedNsUid)}
                countries={countries}
                platforms={platforms}
                handleDeleteClick={this.handleDeleteClick}
              />
            }
          </div>
        </div>
        <SelectSuggestMovieList { ...{ suggestVideoList, timezone }} />
      </div>
    );
  }
}

export default connect(mapStateToProps)(SuggestVideoListForm);
